module.exports = __webpack_public_path__ + "static/98-daf1c7958be08439b355bc0fdc29a93b.png";